export default __webpack_public_path__ + "static/media/galaxy.42e2eba4.glsl";